import Store from "store2";
import * as types from "../mutation-types";
import Vue from 'vue';
// state
export const state = {
  sidebarShow: Store.get('sidebarShow') != null ? Store.get('sidebarShow') : "responsive",
  sidebarMinimize: Store.get('sidebarMinimize'),
  darkMode: Store.get('darkMode')
};

// getters
export const getters = {
  sidebarShow: state => state.sidebarShow,
  sidebarMinimize: state => state.sidebarMinimize,
  darkMode: state => state.darkMode
};

// mutations
export const mutations = {
  [types.TOGGLE_SIDEBAR_DESKTOP](state) {
    const sidebarOpened = [true, "responsive"].includes(state.sidebarShow);
    let sidebarShow = sidebarOpened ? false : "responsive";

    state.sidebarShow = sidebarShow;
    Store('sidebarShow', sidebarShow);
  },

  [types.TOGGLE_SIDEBAR_MOBILE](state) {
    const sidebarClosed = [false, "responsive"].includes(state.sidebarShow);
    let sidebarShow = sidebarClosed ? true : "responsive";

    state.sidebarShow = sidebarShow;
    Store('sidebarShow', sidebarShow);
  },

  [types.TOGGLE](state, variable) {
    let value = !state[variable];

    state[variable] = value;
    Store(variable, value);
  },
  [types.MINIMIZE_SIDEBAR](state) {
    Vue.set(state, 'sidebarMinimize', true);
  },

  [types.SET](state, [variable, value]) {
    state[variable] = value;
    Store(variable, value);
  }
};

// actions
export const actions = {
  toggleSidebarDesktop({ commit }) {
    commit(types.TOGGLE_SIDEBAR_DESKTOP);
  },

  toggleSidebarMobile({ commit }) {
    commit(types.TOGGLE_SIDEBAR_MOBILE);
  },

  toggle({ commit }, payload) {
    commit(types.TOGGLE, payload);
  },
  minimizeSideBar({ commit }) {
    commit(types.MINIMIZE_SIDEBAR);
  },

  set({ commit }, [variable, value]) {
    commit(types.SET, [variable, value]);
  }
};
